import { GlossaryDefinitionComponent } from './glossary-definition/glossary-definition';
import { IonAlphaScrollModule } from 'ionic2-alpha-scroll';
import { NgModule } from '@angular/core';
import { CoinListItemComponent } from './coin-list-item/coin-list-item';
import { IonicModule } from 'ionic-angular/module';
import { CommonModule } from '@angular/common';
import { PricePickerComponent } from './price-picker/price-picker';
import { CoinSearchComponent } from './coin-search/coin-search';
import { SignalViewComponent } from './signal-view/signal-view';
import { PortfolioSummaryComponent } from './portfolio-summary/portfolio-summary';
import { AdminUserComponent } from './admin-user/admin-user';
import { CoinSummaryComponent } from './coin-summary/coin-summary';
import { CoinChartSimpleComponent } from './coin-chart-simple/coin-chart-simple';

//Charts
import { NgxChartsModule } from '@swimlane/ngx-charts'
import { HighchartsChartComponent } from './highcharts/highcharts-chart.component';

import { WatchlistItemComponent } from './watchlist-item/watchlist-item';
import { CoinMarketsComponent } from './coin-markets/coin-markets';
import { MarketExchangeComponent } from './market-exchange/market-exchange';
import { PortfolioAllocationChartComponent } from './portfolio-allocation-chart/portfolio-allocation-chart';
import { CoinChartsComponent } from './coin-charts/coin-charts';
import { WatchlistCardComponent } from './watchlist-card/watchlist-card';
import { AdminUserDetailsComponent } from './admin-user-details/admin-user-details';
import { UserSubscriptionComponent } from './user-subscription/user-subscription';
import { UserSubscriptionStripeComponent } from './user-subscription-stripe/user-subscription-stripe';
import { CoinChartCardComponent } from './coin-chart-card/coin-chart-card';
import { CoinChartSimpleDynamicComponent } from './coin-chart-simple-dynamic/coin-chart-simple-dynamic';
import { AdminUserSubscriptionComponent } from './admin-user-subscription/admin-user-subscription';
import { AdminUserPaymentsComponent } from './admin-user-payments/admin-user-payments';
import { NewsLinkComponent } from './news-link/news-link';
import { AffiliateInfoComponent } from './affiliate-info/affiliate-info';
import { SignalViewDetailsComponent } from './signal-view-details/signal-view-details';
import { PortfolioSummaryHeaderComponent } from './portfolio-summary-header/portfolio-summary-header';
import { PipesModule } from '../pipes/pipes.module';
import { CoinSummaryDetailCardComponent } from './coin-summary-detail-card/coin-summary-detail-card';
import { IntervalPickerComponent } from './interval-picker/interval-picker';
import { NewsListComponent } from './news-list/news-list';
import { NewsCategoriesComponent } from './news-categories/news-categories';
import { NewsFeedsComponent } from './news-feeds/news-feeds';
import { UserAppSettingsComponent } from './user-app-settings/user-app-settings';
import { AddSignalComponent } from './add-signal/add-signal';
import { AddSignalStocksComponent } from './add-signal-stocks/add-signal-stocks';

import { PercentBadgeComponent } from './percent-badge/percent-badge';
import { PortfolioItemComponent } from './portfolio-item/portfolio-item';
import { DisplayPriceComponent } from './display-price/display-price';
import { ExchangeComponent } from './exchange/exchange';
import { TagCloudComponent } from './tag-cloud/tag-cloud';
import { GuideLinkComponent } from './guide-link/guide-link';
import { GlossaryComponent } from './glossary/glossary';
import { HelpComponent } from './help/help';
import { UserSubscriptionCoinbaseComponent } from './user-subscription-coinbase/user-subscription-coinbase';
import { SignalsStatsComponent } from './signals-stats/signals-stats';
import { GuidesCategoriesComponent } from './guides-categories/guides-categories';
import { MenuToggleComponent } from './menu-toggle/menu-toggle';
import { SignalsCalendarComponent } from './signals-calendar/signals-calendar';

import { CalendarModule } from 'ionic3-calendar-en';
import { SignalsListComponent } from './signals-list/signals-list';
import { AddGradeComponent } from './add-grade/add-grade';
import { GradeViewComponent } from './grade-view/grade-view';
import { GradeListComponent } from './grade-list/grade-list';
import { AddReportComponent } from './add-report/add-report';
import { ReportViewComponent } from './report-view/report-view';
import { ReportListComponent } from './report-list/report-list';
import { MarkdownModule } from 'ngx-markdown';
import { StreamListComponent } from './stream-list/stream-list';
import { StreamViewComponent } from './stream-view/stream-view';
import { AddStreamComponent } from './add-stream/add-stream';


@NgModule({
	declarations: [CoinListItemComponent,
    PricePickerComponent,
    CoinSearchComponent,
    SignalViewComponent,
    PortfolioSummaryComponent,
    AdminUserComponent,
    CoinSummaryComponent,
    CoinChartSimpleComponent,
    WatchlistItemComponent,
    CoinMarketsComponent,
    MarketExchangeComponent,
    PortfolioAllocationChartComponent,
    CoinChartsComponent,
    HighchartsChartComponent,
    WatchlistCardComponent,
    AdminUserDetailsComponent,
    UserSubscriptionComponent,
    UserSubscriptionStripeComponent,
    CoinChartCardComponent,
    CoinChartSimpleDynamicComponent,
    AdminUserSubscriptionComponent,
    AdminUserPaymentsComponent,
    NewsLinkComponent,
    AffiliateInfoComponent,
    SignalViewDetailsComponent,
    PortfolioSummaryHeaderComponent,
    CoinSummaryDetailCardComponent,
    IntervalPickerComponent,
    NewsListComponent,
    NewsCategoriesComponent,
    NewsFeedsComponent,
    UserAppSettingsComponent,
    AddSignalComponent,
    AddSignalStocksComponent,
    PercentBadgeComponent,
    PortfolioItemComponent,
    DisplayPriceComponent,
    ExchangeComponent,
    TagCloudComponent,
    GuideLinkComponent,
    GlossaryComponent,
    GlossaryDefinitionComponent,
    HelpComponent,
    UserSubscriptionCoinbaseComponent,
    SignalsStatsComponent,
    GuidesCategoriesComponent,
    MenuToggleComponent,
    SignalsCalendarComponent,
    SignalsListComponent,
    AddGradeComponent,
    GradeViewComponent,
    GradeListComponent,
    AddReportComponent,
    ReportViewComponent,
    ReportListComponent,
    StreamListComponent,
    StreamViewComponent,
    AddStreamComponent,

    ],
	imports: [
    IonicModule,
    CommonModule,
    NgxChartsModule,
    PipesModule,
    IonAlphaScrollModule,
    CalendarModule,
    MarkdownModule
  ],
	exports: [CoinListItemComponent,
    PricePickerComponent,
    CoinSearchComponent,
    SignalViewComponent,
    PortfolioSummaryComponent,
    AdminUserComponent,
    CoinSummaryComponent,
    CoinChartSimpleComponent,
    WatchlistItemComponent,
    CoinMarketsComponent,
    MarketExchangeComponent,
    PortfolioAllocationChartComponent,
    CoinChartsComponent,
    HighchartsChartComponent,
    WatchlistCardComponent,
    AdminUserDetailsComponent,
    UserSubscriptionComponent,
    UserSubscriptionStripeComponent,
    CoinChartCardComponent,
    CoinChartSimpleDynamicComponent,
    AdminUserSubscriptionComponent,
    AdminUserPaymentsComponent,
    NewsLinkComponent,
    AffiliateInfoComponent,
    SignalViewDetailsComponent,
    PortfolioSummaryHeaderComponent,
    CoinSummaryDetailCardComponent,
    IntervalPickerComponent,
    NewsListComponent,
    NewsCategoriesComponent,
    NewsFeedsComponent,
    UserAppSettingsComponent,
    AddSignalComponent,
    PercentBadgeComponent,
    PortfolioItemComponent,
    DisplayPriceComponent,
    ExchangeComponent,
    TagCloudComponent,
    GuideLinkComponent,
    GlossaryComponent,
    GlossaryDefinitionComponent,
    HelpComponent,
    UserSubscriptionCoinbaseComponent,
    SignalsStatsComponent,
    GuidesCategoriesComponent,
    MenuToggleComponent,
    SignalsCalendarComponent,
    SignalsListComponent,
    AddGradeComponent,
    GradeViewComponent,
    GradeListComponent,
    AddReportComponent,
    ReportViewComponent,
    ReportListComponent,
    StreamListComponent,
    StreamViewComponent,
    AddStreamComponent
    ],
  providers: [PipesModule]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts